/****************************************************
 * Module Name:  addMixBucketModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Modal from "react-bootstrap/Modal";
import Constants from "../../utility/constants";

import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Tooltip, Typography } from "@mui/material";
import Select from "react-select";
import CommonSnackbar from "../common/commonSnackBar";
import MixBucketProxy from "../../utility/proxy/manager/mixProxy/mixBucketProxy";
import logo from '../../images/pansuriya.jpg'
import MixShapeProxy from "../../utility/proxy/manager/mixProxy/mixShapeProxy";
import MixSizeProxy from "../../utility/proxy/manager/mixProxy/mixSizeProxy";
import MixColorProxy from "../../utility/proxy/manager/mixProxy/mixColorProxy";
import MixClarityProxy from "../../utility/proxy/manager/mixProxy/mixClarityProxy";
import Utility from "../../utility/utility";
import UserProxy from "../../utility/proxy/manager/userProxy";
import { LoadingButton } from "@mui/lab";
import SaveIcon from '@mui/icons-material/Save';
import StoneTypeProxy from "../../utility/proxy/manager/stoneTypeProxy";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import UserDetailModal from "../operations/userDetailModal";

const fullOptionToValue = (selectedData) => {
  if (selectedData.value !== undefined) {
    return [selectedData.value];
  }
  let newArr = [];
  selectedData.map((option) => {
    if (option.value === undefined) {
      newArr.push(option);
    } else {
      newArr.push(option.value);
    }
    return true;
  });
  return newArr.includes("*") ? [] : newArr;
};

const setPropSourceDataofAlertUsername = (dataToMap) => {
  let newArr = [];
  dataToMap.map((item) => {
    let option = { value: item.id, label: item.id + " | " + item.username };
    newArr.push(option);
    return true;
  });
  return newArr;
};

export default class AddMixBucketModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newShape: this.props.editOperation
        ? {
          value: this.props.sourceData.shapeid,
          label:
            this.props.sourceData.shapeid +
            " | " +
            this.props.sourceData.shape,
        }
        : "",
      newSize: this.props.editOperation
        ? {
          value: this.props.sourceData.sizeid,
          label:
            this.props.sourceData.sizeid + " | " + this.props.sourceData.size,
        }
        : "",
      newColor: this.props.editOperation
        ? {
          value: this.props.sourceData.colorid,
          label:
            this.props.sourceData.colorid +
            " | " +
            this.props.sourceData.color,
        }
        : "",
      newClarity: this.props.editOperation
        ? {
          value: this.props.sourceData.clarityid,
          label:
            this.props.sourceData.clarityid +
            " | " +
            this.props.sourceData.clarity,
        }
        : "",

      newStonetype: this.props.editOperation ? {
        value: this.props.sourceData.stonetypename,
        label: this.props.sourceData.stonetypename +
          " | " +
          this.props.sourceData.stonetypefullname,
      } : "",

      newQty: this.props.editOperation ? this.props.sourceData.qty : 0,
      newDefPurchasePrice: this.props.editOperation
        ? this.props.sourceData.defaultpurchaseprice
        : 0,
      newDefSellPrice: this.props.editOperation
        ? this.props.sourceData.defaultsellprice
        : 0,
      newAvgPrice: this.props.editOperation
        ? this.props.sourceData.avgprice
        : 0,
      newMinAlertQty: this.props.editOperation
        ? this.props.sourceData.minalertqty
        : "",
      newMinAlertUsername: this.props.editOperation
        ? setPropSourceDataofAlertUsername(
          this.props.sourceData.minalertusername
        )
        : "",
      newMaxAlertQty: this.props.editOperation
        ? this.props.sourceData.maxalertqty
        : "",
      newMaxAlertUsername: this.props.editOperation
        ? setPropSourceDataofAlertUsername(
          this.props.sourceData.maxalertusername
        )
        : "",

      showError: false,

      validateBucketPresentSpinner: false,
      showValidationMessage: false,
      bucketAvailable: true,

      shapeOptions: [],
      showShapeLoadSpinner: true,

      sizeOptions: [],
      showSizeLoadSpinner: true,

      colorOptions: [],
      showColorLoadSpinner: true,

      clarityOptions: [],
      showClarityLoadSpinner: true,

      stonetypeOptions: [],
      showStonetypeLoadSpinner: true,

      userOptions: [],
      showUserLoadSpinner: true,

      qtyValidationError: "",
      minalertQtyValidationError: "",
      maxalertQtyValidationError: "",
      defPurchasePriceValidationError: "",
      defSellPriceValidationError: "",

      userMinInputValue: "",
      userMaxInputValue: "",
      debouncedMinInputValue: "",
      debouncedMaxInputValue: "",

      showUserDetailModal: false,
      userDetailContext: "",

    };
    this.getAllSize(false);
    this.getAllColor(false);
    this.getAllClarity(false);
    this.getAllShape(false);
    this.getAllStonetype(false);
    this.getAllUser(false);
  }

  componentDidUpdate(prevProps) {
    this.handleDebounce("userMinInputValue", "debouncedMinInputValue", prevProps);
    this.handleDebounce("userMaxInputValue", "debouncedMaxInputValue", prevProps);
  }

  handleDebounce(inputState, debouncedState, prevProps) {
    if (prevProps[inputState] !== this.state[inputState]) {
      clearTimeout(this[`${inputState}TimeoutId`]);

      this[`${inputState}TimeoutId`] = setTimeout(() => {
        this.setState({ [debouncedState]: this.state[inputState] });
      }, 500);
    }
  }

  componentWillUnmount() {
    clearTimeout(this.userMinInputValueTimeoutId);
    clearTimeout(this.userMaxInputValueTimeoutId);
  }

  getFilteredUserOptions(debouncedValue) {
    if (!debouncedValue) {
      return this.state.userOptions.slice(0, 100);
    }
    return this.state.userOptions
      .filter(option =>
        option.label.toLowerCase().includes(debouncedValue.toLowerCase())
      )
      .slice(0, 500);
  }

  getAllStonetype = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showStonetypeLoadSpinner: true });
    StoneTypeProxy.GetAllStoneType((response) => this.setAllStonetype(response));
  }

  setAllStonetype = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.name, label: data.name + " | " + data.fullname };
      optionsArray.push(option);

      return true;
    });

    this.setState({
      stonetypeOptions: optionsArray,
      showStonetypeLoadSpinner: false,
    });
  }

  getAllShape = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showShapeLoadSpinner: true });
    MixShapeProxy.GetAllShapeMini((response) => this.setAllShapeData(response));
  };

  setAllShapeData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.id + " | " + data.name };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      shapeOptions: optionsArray,
      showShapeLoadSpinner: false,
    });
  };

  getAllSize = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showSizeLoadSpinner: true });
    MixSizeProxy.GetAllSizeMini((response) => this.setAllSizeData(response));
  };

  setAllSizeData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.id + " | " + data.name };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      sizeOptions: optionsArray,
      showSizeLoadSpinner: false,
    });
  };

  getAllColor = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showColorLoadSpinner: true });
    MixColorProxy.GetAllColorMini((response) => this.setAllColorData(response));
  };

  setAllColorData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.id + " | " + data.name };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      colorOptions: optionsArray,
      showColorLoadSpinner: false,
    });
  };

  getAllClarity = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showClarityLoadSpinner: true });
    MixClarityProxy.GetAllClarityMini((response) =>
      this.setAllClarityData(response)
    );
  };

  setAllClarityData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.id + " | " + data.name };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      clarityOptions: optionsArray,
      showClarityLoadSpinner: false,
    });
  };

  getAllUser = (bAnimateSpinner) => {
    bAnimateSpinner && this.setState({ showUserLoadSpinner: true });
    UserProxy.GetAllGenericUserMini((response) =>
      this.setAllUserData(response)
    );
  };

  setAllUserData = (response) => {
    let optionsArray = [];
    response.map((data) => {
      let option = { value: data.id, label: data.id + " | " + data.username };
      optionsArray.push(option);

      return true;
    });
    this.setState({
      userOptions: optionsArray,
      newMinAlertUsername:
        this.state.newMinAlertUsername === "" && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newMinAlertUsername,
      newMaxAlertUsername:
        this.state.newMaxAlertUsername === "" && optionsArray.length > 0
          ? optionsArray[0]
          : this.state.newMaxAlertUsername,
      showUserLoadSpinner: false,
    });
  };

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      shapeid: this.state.newShape.value,
      sizeid: this.state.newSize.value,
      colorid: this.state.newColor.value,
      clarityid: this.state.newClarity.value,
      stonetypename: this.state.newStonetype.value,
      qty: this.state.newQty,
      minalertqty: this.state.newMinAlertQty,
      maxalertqty: this.state.newMaxAlertQty,
      avgprice: this.state.newAvgPrice,
      minalertusername: fullOptionToValue(this.state.newMinAlertUsername),
      maxalertusername: fullOptionToValue(this.state.newMaxAlertUsername),
      defaultpurchaseprice: this.state.newDefPurchasePrice,
      defaultsellprice: this.state.newDefSellPrice
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateBucketPresent = () => {
    if (
      !this.state.newShape ||
      !this.state.newSize ||
      !this.state.newColor ||
      !this.state.newClarity ||
      !this.state.newStonetype
    )
      return;

    this.setState({
      validateBucketPresentSpinner: true,
    });

    let shapeid = this.state.newShape.value;
    let sizeid = this.state.newSize.value;
    let colorid = this.state.newColor.value;
    let clarityid = this.state.newClarity.value;
    let stonetypename = this.state.newStonetype.value;

    MixBucketProxy.CheckBucketAvailable(
      shapeid,
      colorid,
      sizeid,
      clarityid,
      stonetypename,
      (response) => {
        //if we got response that means bucket is present at backend
        if (response) {
          //BucketName already present
          this.setState({
            validateBucketPresentSpinner: false,
            showValidationMessage: true,
            bucketAvailable: false,
          });
        } else {
          //BucketName not available, so can be used
          this.setState({
            validateBucketPresentSpinner: false,
            showValidationMessage: true,
            bucketAvailable: true,
          });
        }
      }
    );
  };

  buttonDisable = () => {
    if (
      this.props.editOperation &&
      (this.state.qtyValidationError.length !== 0 ||
        this.state.minalertQtyValidationError.length !== 0 ||
        this.state.newMinAlertUsername.length === 0 ||
        this.state.newMaxAlertUsername.length === 0)
    )
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.bucketAvailable ||
        this.state.qtyValidationError.length !== 0 ||
        this.state.minalertQtyValidationError.length !== 0 ||
        this.state.newMinAlertQty.length === 0 ||
        this.state.newQty.length === 0 ||
        this.state.newAvgPrice.length === 0 ||
        this.state.newMinAlertUsername.length === 0 ||
        this.state.newMaxAlertUsername.length === 0 ||
        !this.state.newDefPurchasePrice ||
        !this.state.newDefSellPrice
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add bucket validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        {this.state.showUserDetailModal && (
          <>
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                backdropFilter: "blur(1px)",
                zIndex: 1299,
              }}
            />
            <UserDetailModal
              show={true}
              handleClose={() => this.setState({ showUserDetailModal: false })}
              handleSelect={(selectedOption) => {
                const selectedUsers = this.state.userOptions.filter(opt =>
                  selectedOption.includes(opt.value)
                );
                if (this.state.userDetailContext === "MIN") {
                  this.setState({ newMinAlertUsername: selectedUsers });
                } else if (this.state.userDetailContext === "MAX") {
                  this.setState({ newMaxAlertUsername: selectedUsers });
                }
                this.setState({ showUserDetailModal: false });
              }}
              userids={this.state.userOptions.map(opt => opt.value)}
              selectedIds={
                this.state.userDetailContext === "MIN"
                  ? (Array.isArray(this.state.newMinAlertUsername) ? this.state.newMinAlertUsername.map(u => u.value) : this.state.newMinAlertUsername.value)
                  : this.state.userDetailContext === "MAX"
                    ? (Array.isArray(this.state.newMaxAlertUsername) ? this.state.newMaxAlertUsername.map(u => u.value) : this.state.newMaxAlertUsername.value)
                    : []
              }
              usertype={"U"}
              loading={this.state.showUserDetailModal}
              isMulti={true}
            />
          </>
        )}


        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} size="lg" enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation ? "Edit Bucket" : "Add New Bucket"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>

            <Box
              sx={{
                width: "100%",
                "& .css-2vawn2-MuiTypography-root": {
                  alignSelf: "center",
                },
              }}
            >

              {this.props.editOperation ? (
                <Box sx={{ display: "flex", width: "100%" }}>
                  <Typography sx={{ width: "30%" }}>
                    Bucket Id
                  </Typography>
                  <Typography sx={{ fontWeight: "bold" }}>
                    {this.props.sourceData.id}
                  </Typography>
                </Box>
              ) : null}

              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%", alignSelf: "center" }}>
                  Stonetype<sup style={{ color: "red" }}>*</sup>
                </Typography>

                {this.props.editOperation ? (
                  <Box sx={{ width: "70%" }}>
                    <Typography
                      sx={{ alignSelf: "center", whiteSpace: "nowrap" }}
                    >
                      {this.props.sourceData.stonetypename +
                        " | " +
                        this.props.sourceData.stonetypefullname}
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ width: "70%", display: "flex", "& .basic-single": { width: "90%" } }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      className="basic-single"
                      classNamePrefix="select"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={this.state.newStonetype}
                      isSearchable={true}
                      name="Stonetype"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={this.state.stonetypeOptions}
                      onChange={(selectedOption) =>
                        this.setState({
                          newStonetype: selectedOption,
                        })
                      }
                      onBlur={() => this.validateBucketPresent()}
                    />

                    {this.state.showShapeLoadSpinner ? (
                      <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                    ) : (
                      <Tooltip title="Reload">
                        <RefreshOutlinedIcon
                          color="primary"
                          fontSize="medium"
                          onClick={() => this.getAllShape(true)}
                          sx={{ cursor: "pointer", mt: 1, ml: 1 }}
                        />
                      </Tooltip>
                    )}
                  </Box>
                )}
              </Box>

              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%", alignSelf: "center" }}>
                  Shape<sup style={{ color: "red" }}>*</sup>
                </Typography>

                {this.props.editOperation ? (
                  <Box sx={{ width: "70%" }}>
                    <Typography
                      sx={{ alignSelf: "center", whiteSpace: "nowrap" }}
                    >
                      {this.props.sourceData.shapeid +
                        " | " +
                        this.props.sourceData.shape}
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ width: "70%", display: "flex", "& .basic-single": { width: "90%" } }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      className="basic-single"
                      classNamePrefix="select"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={this.state.newShape}
                      isSearchable={true}
                      name="Shape"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={this.state.shapeOptions}
                      onChange={(selectedOption) =>
                        this.setState({
                          newShape: selectedOption,
                        })
                      }
                      onBlur={() => this.validateBucketPresent()}
                    />

                    {this.state.showShapeLoadSpinner ? (
                      <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                    ) : (
                      <Tooltip title="Reload">
                        <RefreshOutlinedIcon
                          color="primary"
                          fontSize="medium"
                          onClick={() => this.getAllShape(true)}
                          sx={{ cursor: "pointer", mt: 1, ml: 1 }}
                        />
                      </Tooltip>
                    )}
                  </Box>
                )}
              </Box>

              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%", alignSelf: "center" }}>
                  Size<sup style={{ color: "red" }}>*</sup>
                </Typography>

                {this.props.editOperation ? (
                  <Box sx={{ width: "70%" }}>
                    <Typography
                      sx={{ alignSelf: "center", whiteSpace: "nowrap" }}
                    >
                      {this.props.sourceData.sizeid +
                        " | " +
                        this.props.sourceData.size}
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ width: "70%", display: "flex", "& .basic-single": { width: "90%" } }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      className="basic-single"
                      classNamePrefix="select"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={this.state.newSize}
                      isSearchable={true}
                      name="Size"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={this.state.sizeOptions}
                      onChange={(selectedOption) =>
                        this.setState({
                          newSize: selectedOption,
                        })
                      }
                      onBlur={() => this.validateBucketPresent()}
                    />

                    {this.state.showSizeLoadSpinner ? (
                      <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                    ) : (
                      <Tooltip title="Reload">
                        <RefreshOutlinedIcon
                          color="primary"
                          fontSize="medium"
                          onClick={() => this.getAllSize(true)}
                          sx={{ cursor: "pointer", mt: 1, ml: 1 }}
                        />
                      </Tooltip>
                    )}
                  </Box>
                )}
              </Box>

              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%", alignSelf: "center" }}>
                  Color<sup style={{ color: "red" }}>*</sup>
                </Typography>

                {this.props.editOperation ? (
                  <Box sx={{ width: "70%" }}>
                    <Typography
                      sx={{ alignSelf: "center", whiteSpace: "nowrap" }}
                    >
                      {this.props.sourceData.colorid +
                        " | " +
                        this.props.sourceData.color}
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ width: "70%", display: "flex", "& .basic-single": { width: "90%" } }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      className="basic-single"
                      classNamePrefix="select"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={this.state.newColor}
                      isSearchable={true}
                      name="Color"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={this.state.colorOptions}
                      onChange={(selectedOption) =>
                        this.setState({
                          newColor: selectedOption,
                        })
                      }
                      onBlur={() => this.validateBucketPresent()}
                    />

                    {this.state.showColorLoadSpinner ? (
                      <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                    ) : (
                      <Tooltip title="Reload">
                        <RefreshOutlinedIcon
                          color="primary"
                          fontSize="medium"
                          onClick={() => this.getAllColor(true)}
                          sx={{ cursor: "pointer", mt: 1, ml: 1 }}
                        />
                      </Tooltip>
                    )}
                  </Box>
                )}
              </Box>

              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%", alignSelf: "center" }}>
                  Clarity<sup style={{ color: "red" }}>*</sup>
                </Typography>

                {this.props.editOperation ? (
                  <Box sx={{ width: "70%" }}>
                    <Typography
                      sx={{ alignSelf: "center", whiteSpace: "nowrap" }}
                    >
                      {this.props.sourceData.clarityid +
                        " | " +
                        this.props.sourceData.clarity}
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ width: "70%", display: "flex", "& .basic-single": { width: "90%" } }}>
                    <Select menuPlacement="auto"
                      blurInputOnSelect={false}
                      className="basic-single"
                      classNamePrefix="select"
                      getOptionLabel={(option) => option.label}
                      getOptionValue={(option) => option.value}
                      value={this.state.newClarity}
                      isSearchable={true}
                      name="Clarity"
                      menuPortalTarget={document.body}
                      styles={Constants.Styles}
                      options={this.state.clarityOptions}
                      onChange={(selectedOption) =>
                        this.setState({
                          newClarity: selectedOption,
                        })
                      }
                      onBlur={() => this.validateBucketPresent()}
                    />

                    {this.state.showClarityLoadSpinner ? (
                      <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                    ) : (
                      <Tooltip title="Reload">
                        <RefreshOutlinedIcon
                          color="primary"
                          fontSize="medium"
                          onClick={() => this.getAllClarity(true)}
                          sx={{ cursor: "pointer", mt: 1, ml: 1 }}
                        />
                      </Tooltip>
                    )}
                  </Box>
                )}
              </Box>

              <Box display={"flex"} alignItems="center">
                <Box minWidth={"30%"}></Box>
                <Box>
                  {this.state.validateBucketPresentSpinner ? (
                    <CircularProgress size="1rem" />
                  ) : !this.state.showValidationMessage ? (
                    <Box>&nbsp;</Box>
                  ) : this.state.bucketAvailable ? (
                    <font color="green">Bucket available</font>
                  ) : (
                    <font color="red">Bucket not available</font>
                  )}
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", "& .MuiTextField-root": { margin: "16px 0 0" } }}>
                <Box sx={{ width: "30%" }}>
                  <Typography>
                    Default Purchase Price<sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </Box>

                <Box sx={{ width: "68%" }}>
                  <TextField
                    margin="normal"
                    size="small"
                    fullWidth
                    type={"number"}
                    label="Default Purchase Price (required)"
                    placeholder="Default Purchase Price should not be empty"
                    value={this.state.newDefPurchasePrice}
                    onChange={(e) =>
                      this.setState({
                        newDefPurchasePrice: e.target.value,
                        defPurchasePriceValidationError: Utility.CheckisNumberPositive(
                          e.target.value
                        )
                          ? ""
                          : "Default PurchasePrice Should not be a negative number ",
                      })
                    }
                    helperText={this.state.defPurchasePriceValidationError}
                    error={this.state.defPurchasePriceValidationError.length > 0}
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", "& .MuiTextField-root": { margin: "16px 0 0" } }}>
                <Box sx={{ width: "30%" }}>
                  <Typography>
                    Default Sell Price<sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </Box>

                <Box sx={{ width: "68%" }}>
                  <TextField
                    margin="normal"
                    size="small"
                    fullWidth
                    type={"number"}
                    label="Default Sell Price (required)"
                    placeholder="Default Sell Price should not be empty"
                    value={this.state.newDefSellPrice}
                    onChange={(e) =>
                      this.setState({
                        newDefSellPrice: e.target.value,
                        defSellPriceValidationError: Utility.CheckisNumberPositive(
                          e.target.value
                        )
                          ? ""
                          : "Default Sell Price Should not be a negative number ",
                      })
                    }
                    helperText={this.state.defSellPriceValidationError}
                    error={this.state.defSellPriceValidationError.length > 0}
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", "& .MuiTextField-root": { margin: "16px 0 0" } }}>
                <Box sx={{ width: "30%" }}>
                  <Typography>
                    Quantity<sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </Box>

                <Box sx={{ width: "68%" }}>
                  <TextField
                    margin="normal"
                    size="small"
                    fullWidth
                    type={"number"}
                    label="Quantity (carats) (required)"
                    placeholder="Quantity should not be empty"
                    value={this.state.newQty}
                    onChange={(e) =>
                      this.setState({
                        newQty: e.target.value,
                        qtyValidationError: Utility.CheckisNumberPositive(
                          e.target.value
                        )
                          ? ""
                          : "Quantity Should not be a negative number ",
                      })
                    }
                    helperText={this.state.qtyValidationError}
                    error={this.state.qtyValidationError.length > 0}
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", "& .MuiTextField-root": { margin: "16px 0 0" } }}>
                <Box sx={{ width: "30%" }}>
                  <Typography>
                    Average Price<sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </Box>

                <Box sx={{ width: "68%" }}>
                  <TextField
                    margin="normal"
                    size="small"
                    fullWidth
                    type={"number"}
                    label="Average Price (required)"
                    placeholder="Average Price should not be empty"
                    value={this.state.newAvgPrice}
                    onChange={(e) =>
                      this.setState({
                        newAvgPrice: e.target.value,
                      })
                    }
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", "& .MuiTextField-root": { margin: "16px 0 0" } }}>
                <Box sx={{ width: "30%" }}>
                  <Typography>
                    Min Alert Quantity<sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </Box>

                <Box sx={{ width: "68%" }}>
                  <TextField
                    margin="normal"
                    size="small"
                    fullWidth
                    type={"number"}
                    label="Min Alert Quantity (required)"
                    placeholder="Min Alert Quantity should not be empty"
                    value={this.state.newMinAlertQty}
                    onChange={(e) =>
                      this.setState({
                        newMinAlertQty: e.target.value,
                        minalertQtyValidationError:
                          Utility.CheckisNumberGreaterThanZero(e.target.value) &&
                            parseInt(e.target.value) <=
                            parseInt(this.state.newMaxAlertQty)
                            ? ""
                            : "Min Alert quantity should be a Valid number greater than 0 and less than or equal to Max Alert quantity",
                        maxalertQtyValidationError:
                          Utility.CheckisNumberGreaterThanZero(e.target.value) &&
                            parseInt(e.target.value) <=
                            parseInt(this.state.newMaxAlertQty)
                            ? ""
                            : "Max Alert quantity should be a Valid number greater than 0 and less than or equal to Min Alert quantity",
                      })
                    }
                    helperText={this.state.minalertQtyValidationError}
                    error={this.state.minalertQtyValidationError.length > 0}
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", "& .MuiTextField-root": { margin: "16px 0 0" } }}>
                <Box sx={{ width: "30%" }}>
                  <Typography>
                    Max Alert Quantity<sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </Box>

                <Box sx={{ width: "68%" }}>
                  <TextField
                    margin="normal"
                    size="small"
                    fullWidth
                    type={"number"}
                    label="Max Alert Quantity (required)"
                    placeholder="Max Alert Quantity should not be empty"
                    value={this.state.newMaxAlertQty}
                    onChange={(e) =>
                      this.setState({
                        newMaxAlertQty: e.target.value,
                        maxalertQtyValidationError:
                          Utility.CheckisNumberGreaterThanZero(e.target.value) &&
                            parseInt(e.target.value) >=
                            parseInt(this.state.newMinAlertQty)
                            ? ""
                            : "Max Alert quantity should be a Valid number greater than 0 and less than or equal to Min Alert quantity",
                        minalertQtyValidationError:
                          Utility.CheckisNumberGreaterThanZero(e.target.value) &&
                            parseInt(e.target.value) >=
                            parseInt(this.state.newMinAlertQty)
                            ? ""
                            : "Min Alert quantity should be a Valid number greater than 0 and less than or equal to Max Alert quantity",
                      })
                    }
                    helperText={this.state.maxalertQtyValidationError}
                    error={this.state.maxalertQtyValidationError.length > 0}
                  />
                </Box>
              </Box>

              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%", alignSelf: "center" }}>
                  Min Alert Username
                </Typography>

                <Box sx={{ width: "70%", display: "flex", "& .basic-single": { width: "90%" } }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    value={this.state.newMinAlertUsername}
                    isSearchable={true}
                    isMulti
                    closeMenuOnSelect={false}
                    name="Alert Username"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.getFilteredUserOptions(this.state.debouncedMinInputValue)}
                    onChange={(selectedOption) =>
                      this.setState({
                        newMinAlertUsername: selectedOption,
                      })
                    }
                    inputValue={this.state.userMinInputValue}
                    onInputChange={(inputValue) => this.setState({ userMinInputValue: inputValue })}
                  />
                  <Tooltip title="View More Data">
                    <OpenInNewIcon
                      onClick={() => this.setState({ userDetailContext: "MIN", showUserDetailModal: true })}
                      sx={{ cursor: "pointer", mt: 1, ml: 1 }}
                      fontSize="small"
                      color="action"
                    />
                  </Tooltip>
                  {this.state.showUserLoadSpinner ? (
                    <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                  ) : (
                    <Tooltip title="Reload">
                      <RefreshOutlinedIcon
                        color="primary"
                        fontSize="medium"
                        onClick={() => this.getAllUser(true)}
                        sx={{ cursor: "pointer", mt: 1, ml: 1 }}
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>

              <Box sx={{ display: "flex", mt: 2 }}>
                <Typography sx={{ width: "30%", alignSelf: "center" }}>
                  Max Alert Username
                </Typography>
                <Box sx={{ width: "70%", display: "flex", "& .basic-single": { width: "90%" } }}>
                  <Select menuPlacement="auto"
                    blurInputOnSelect={false}
                    className="basic-single"
                    classNamePrefix="select"
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                    value={this.state.newMaxAlertUsername}
                    isSearchable={true}
                    isMulti
                    closeMenuOnSelect={false}
                    name="Alert Username"
                    menuPortalTarget={document.body}
                    styles={Constants.Styles}
                    options={this.getFilteredUserOptions(this.state.debouncedMaxInputValue)}
                    onChange={(selectedOption) => {
                      this.setState({
                        newMaxAlertUsername: selectedOption,
                      })
                    }
                    }
                    inputValue={this.state.userMaxInputValue}
                    onInputChange={(inputValue) => this.setState({ userMaxInputValue: inputValue })}
                  />
                  <Tooltip title="View More Data">
                    <OpenInNewIcon
                      onClick={() => this.setState({ userDetailContext: "MAX", showUserDetailModal: true })}
                      sx={{ cursor: "pointer", mt: 1, ml: 1 }}
                      fontSize="small"
                      color="action"
                    />
                  </Tooltip>
                  {this.state.showUserLoadSpinner ? (
                    <CircularProgress size="1em" sx={{ mt: 1.5, ml: 0.7 }} />
                  ) : (
                    <Tooltip title="Reload">
                      <RefreshOutlinedIcon
                        color="primary"
                        fontSize="medium"
                        onClick={() => this.getAllUser(true)}
                        sx={{ cursor: "pointer", mt: 1, ml: 1 }}
                      />
                    </Tooltip>
                  )}
                </Box>
              </Box>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            {this.props.saveButton ? (
              <LoadingButton
                loading={this.props.loading}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
                onClick={() => this.handleSave()}
                disabled={this.buttonDisable()}
                sx={{ mr: 1 }}
              >
                Save
              </LoadingButton>
            ) : null}
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
